export default function capitalize(str = "") {
  let result = str.toLowerCase();
  let first = result[0].toUpperCase();
  result = `${first}${result.slice(1)}`;
  return result;
}
